<template>
  <div class="OuterOrderOffertDetail-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
           编辑料单
          </div>
          <div class="card-content" v-loading="loading">
            <div>
              <span style="color:#99a9bf">生产单号：</span>
              <span style="color:#409EFF;font-weight: 500">{{orderinfo.produnum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">订单号：</span>
              <span>{{orderinfo.ordernum}}</span>
              <span style="color:#99a9bf;margin-left: 20px">详细地址：</span>
              <span>{{orderinfo.address}}</span>
              <span style="color:#99a9bf;margin-left: 20px">色板来源：</span>
              <span>{{orderinfo.source}}</span>
<!--              <span v-if="orderinfo.source===0">厂部标准色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===1">客户提供色板</span>-->
<!--              <span style="color:#F56C6C" v-if="orderinfo.source===2">厂部定制色板</span>-->
            </div>
            <div style="margin-top: 20px">
              <span style="color:#99a9bf;">设计师：</span>
              <span>{{splitInfo.splitname}}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单日期：</span>
              <span>{{splitInfo.splittime}}</span>
            </div>
            <div style="margin-top: 20px;color:#F56C6C;">
              <span style=""><i class="el-icon-warning-outline"></i> 温馨提示：订单排产之后添加/删除部件或变更部件数量将会变更生产部件条码</span>
            </div>
            <div style="padding-top: 30px;border-top: 1px solid #f5f7fa;margin-top:30px;">
              <el-form :inline="true" size="small" :model="searchForm">
                <el-form-item label="区域">
                  <el-select v-model="searchForm.area" style="width: 150px" filterable clearable>
                    <el-option
                      v-for="item in searchForm.areaList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="分类">
                  <el-select v-model="searchForm.type" style="width: 100px" filterable clearable>
                    <el-option
                      v-for="item in searchForm.typeList"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="搜索关键字">
                  <el-input @keyup.enter.native="searchMaterial" v-model="searchForm.search"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="searchMaterial" icon="el-icon-search">搜索</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button @click="changeRecord" icon="el-icon-document">变更记录</el-button>
                  <el-tooltip class="item" effect="dark" content="此订单为多工厂订单, 只能编辑与删除" placement="top" :disabled="(orderinfo.ismultifactory!==1)">
                    <div style="display: inline-block">
                      <el-button type="primary" @click="editData(null,0)" :disabled="(orderinfo.ismultifactory === 1)" icon="el-icon-plus">添加</el-button>
                    </div>
                  </el-tooltip>
                </el-form-item>
<!--                <el-form-item style="float: right;">-->
<!--                  <span style="margin-right:20px;">数量合计：<span style="font-size: 16px;font-weight: 500;color: #409EFF">{{ totalCount }}</span></span>-->
<!--                  <span>金额合计：<span style="font-size: 16px;font-weight: 500;color: #409EFF">{{ totalMoney }}</span></span>-->
<!--                </el-form-item>-->
              </el-form>
              <div v-loading="materialloading" style="height: 490px;width: 100%">
                <pl-table
                  :key="tableKey"
                  height="490px"
                  :datas="materialTableData"
                  :data="materialTableData"
                  use-virtual
                  :pagination-show="false"
                  size="small"
                  :row-class-name="tableRowClassName"
                  :row-height="45">
                  <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed />
                  <pl-table-column prop="area" label="区域" width="120" show-overflow-tooltip />
                  <pl-table-column prop="type" label="分类" width="80" show-overflow-tooltip />
                  <pl-table-column prop="name" label="名称" width="160" show-overflow-tooltip />
                  <pl-table-column prop="material" label="基材" width="80" show-overflow-tooltip />
                  <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip />
                  <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip />
                  <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip />
                  <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip />
                  <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip />
                  <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip />
                  <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip />
                  <pl-table-column prop="color" label="颜色" width="140" show-overflow-tooltip />
                  <pl-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
                  <pl-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    width="200">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="editData(scope.row,1)" icon="el-icon-edit">编辑</el-button>
                      <el-button size="mini" @click="delData(scope.row)" icon="el-icon-delete">删除</el-button>
                    </template>
                  </pl-table-column>
                </pl-table>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="70px" size="small">
        <el-row>
          <el-col :span="10">
            <el-form-item label="序号" prop="xuhao">
              <el-input v-model="editForm.xuhao" maxlength="30">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="区域" prop="area">
              <el-input v-model="editForm.area" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="分类" prop="type">
              <el-input v-model="editForm.type" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="名称" prop="name">
            <el-input v-model="editForm.name" maxlength="50">
            </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="基材" prop="material">
              <el-input v-model="editForm.material" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="高/长" prop="high">
              <el-input v-model="editForm.high" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="宽" prop="width">
              <el-input v-model="editForm.width" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="L宽" prop="lwidth">
              <el-input v-model="editForm.lwidth" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="厚" prop="ply">
              <el-input v-model="editForm.ply" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数量" prop="num">
              <el-input v-model="editForm.num" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数值" prop="val">
              <el-input v-model="editForm.val" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位" prop="unit">
              <el-input v-model="editForm.unit" maxlength="50">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="颜色" prop="color" style="width: 100%">
          <el-input v-model="editForm.color" style="width: 100%" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 100%">
          <el-input type="textarea" v-model="editForm.remark" maxlength="200" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="料单变更记录"
      :visible.sync="changeRecordDialog"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-loading="changeRecordLoading" style="height:300px;">
        <pl-table
          height="300px"
          :datas="changeRecordData"
          :data="changeRecordData"
          border
          style="width: 100%"
          :pagination-show="false"
          size="small"
          :row-height="45">
          <pl-table-column
            prop="username"
            :resizable="false"
            label="变更人"
            align="center"
            width="100">
          </pl-table-column>
          <pl-table-column
            prop="time"
            :resizable="false"
            align="center"
            label="变更时间"
            width="160">
          </pl-table-column>
          <pl-table-column
            prop="content"
            :resizable="false"
            label="变更内容"
            min-width="100">
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getOrderDetail, getErpOrderMaterialDetail, editMaterialdata, getOrderMchangelog, delMaterialdata } from '@/api/erp'

export default {
  name: 'ProductionBillChange',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      orderid: '',
      loading: false,
      tableKey: '',
      materialloading: false,
      materialTableData: [],
      orderinfo: [],
      splitInfo: [],
      searchForm: {
        area: '',
        type: '',
        search: '',
        areaList: [],
        typeList: []
      },
      totalCount: 0,
      totalMoney: 0,
      allMaterialData: [],
      editTitle: '添加部件',
      editVisible: false,
      editloading: false,
      editForm: {
        mdid: null,
        xuhao: '',
        area: '',
        type: '',
        name: '',
        material: '',
        high: '',
        width: '',
        lwidth: '',
        ply: '',
        num: '',
        val: '',
        unit: '',
        color: '',
        remark: ''
      },
      editRules: {
        xuhao: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        type: [{ required: true, message: '请输入分类', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }]
      },
      changeRecordDialog: false,
      changeRecordLoading: false,
      changeRecordData: []
    }
  },
  created() {
    this.tempRoute = Object.assign({}, this.$route)
    this.orderid = this.$route.params && this.$route.params.id
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      getOrderDetail({ orderid: this.orderid, userid: this.user.dUserid }).then(response => {
        this.orderinfo = response.data.orderDetail
        console.log(this.orderinfo)
        this.splitInfo = response.data.splitInfo
        let pageTitle = ''
        if (this.orderinfo.bid === 3) {
          pageTitle = `编辑料单 ${this.orderinfo.ordernum}`
        } else {
          pageTitle = `编辑料单 ${this.orderinfo.produnum}`
        }
        document.title = pageTitle
        const route = Object.assign({}, this.tempRoute, { title: pageTitle })
        this.$store.dispatch('tagsView/updateVisitedView', route)
        this.loading = false
        this.getMaterialDetail()
      }).catch(() => {
        this.loading = false
      })
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialloading = true
      this.searchForm.area = ''
      this.searchForm.type = ''
      this.searchForm.search = ''
      this.totalMoney = 0
      this.totalCount = 0
      getErpOrderMaterialDetail({ orderid: this.orderid }).then(response => {
        this.tableKey = new Date().getTime()
        this.materialTableData = response.data
        this.allMaterialData = response.data
        let areaArray = []
        let typeArray = []
        let money = 0
        let count = 0
        for (let item of this.materialTableData) {
          let haveArea = false
          for (let i = 0; i < areaArray.length; i++) {
            if (areaArray[i] === item.area) {
              haveArea = true
              break
            }
          }
          if (!haveArea) {
            areaArray.push(item.area)
          }
          let haveType = false
          for (let i = 0; i < typeArray.length; i++) {
            if (typeArray[i] === item.type) {
              haveType = true
              break
            }
          }
          if (!haveType) {
            typeArray.push(item.type)
          }
          money += item.total
          if (item.num !== null && item.num !== '' && item.num !== undefined) {
            count += parseInt(item.num)
          }
        }
        this.totalMoney = money.toFixed(2)
        this.totalCount = parseInt(count)
        this.searchForm.areaList = areaArray
        this.searchForm.typeList = typeArray
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    searchMaterial() {
      let newMaterial = []
      let money = 0
      let count = 0
      for (let item of this.allMaterialData) {
        let flage = true
        if (this.searchForm.area !== '') {
          if (item.area !== this.searchForm.area) {
            flage = false
          }
        }
        if (this.searchForm.type !== '') {
          if (item.type !== this.searchForm.type) {
            flage = false
          }
        }
        if (this.searchForm.search !== '') {
          if (item.name.indexOf(this.searchForm.search) < 0 && item.xuhao.indexOf(this.searchForm.search) < 0 && item.material.indexOf(this.searchForm.search) < 0 && item.color.indexOf(this.searchForm.search) < 0) {
            flage = false
          }
        }
        if (flage) {
          money += item.total
          if (item.num !== null && item.num !== '' && item.num !== undefined) {
            count += parseInt(item.num)
          }
          newMaterial.push(item)
        }
      }
      this.totalMoney = money.toFixed(2)
      this.totalCount = parseInt(count)
      this.materialTableData = newMaterial
    },
    editData(row, n) {
      if (n === 0) {
        this.editTitle = '添加部件'
        this.editForm.mdid = null
        this.editForm.xuhao = ''
        this.editForm.area = ''
        this.editForm.type = ''
        this.editForm.name = ''
        this.editForm.material = ''
        this.editForm.high = ''
        this.editForm.width = ''
        this.editForm.lwidth = ''
        this.editForm.ply = ''
        this.editForm.num = ''
        this.editForm.val = ''
        this.editForm.unit = ''
        this.editForm.color = ''
        this.editForm.remark = ''
      } else {
        this.editTitle = '编辑部件'
        this.editForm.mdid = row.mdid
        this.editForm.xuhao = row.xuhao
        this.editForm.area = row.area
        this.editForm.type = row.type
        this.editForm.name = row.name
        this.editForm.material = row.material
        this.editForm.high = row.high
        this.editForm.width = row.width
        this.editForm.lwidth = row.lwidth
        this.editForm.ply = row.ply
        this.editForm.num = row.num
        this.editForm.val = row.val
        this.editForm.unit = row.unit
        this.editForm.color = row.color
        this.editForm.remark = row.remark
      }
      this.editVisible = true
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isedited === 1) {
        return 'warning-row'
      }
      return ''
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              orderid: this.orderid,
              userid: this.user.dUserid,
              mdid: this.editForm.mdid,
              xuhao: this.editForm.xuhao,
              area: this.editForm.area,
              type: this.editForm.type,
              name: this.editForm.name,
              material: this.editForm.material,
              high: this.editForm.high,
              width: this.editForm.width,
              lwidth: this.editForm.lwidth,
              ply: this.editForm.ply,
              num: this.editForm.num,
              val: this.editForm.val,
              unit: this.editForm.unit,
              color: this.editForm.color,
              remark: this.editForm.remark
            }
            editMaterialdata(data).then(response => {
              if (this.editForm.mdid !== null) {
                this.$message({
                  message: '部件修改成功',
                  type: 'success'
                })
                if (response.data !== null && response.data !== undefined) {
                  let index = null
                  for (let i = 0; i < this.materialTableData.length; i++) {
                    if (this.materialTableData[i].mdid === response.data.mdid) {
                      index = i
                      break
                    }
                  }
                  if (index !== null) {
                    this.materialTableData.splice(index, 1, response.data)
                  }

                  let aindex = null
                  for (let i = 0; i < this.allMaterialData.length; i++) {
                    if (this.allMaterialData[i].mdid === response.data.mdid) {
                      aindex = i
                      break
                    }
                  }
                  if (aindex !== null) {
                    this.allMaterialData.splice(aindex, 1, response.data)
                  }
                }
              } else {
                this.$message({
                  message: '部件添加成功',
                  type: 'success'
                })
                this.materialTableData.push(response.data)
                this.allMaterialData = this.materialTableData
              }
              this.editVisible = false
              this.editloading = false
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    changeRecord() {
      this.changeRecordDialog = true
      this.changeRecordLoading = true
      getOrderMchangelog({ orderid: this.orderid }).then(response => {
        this.changeRecordData = response.data
        this.changeRecordLoading = false
      }).catch(() => {
        this.changeRecordLoading = false
      })
    },
    delData(row) {
      this.$confirm('此操作将删除该部件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        delMaterialdata({ mdid: row.mdid, userid: this.user.dUserid }).then(response => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          let index = null
          for (let i = 0; i < this.materialTableData.length; i++) {
            if (this.materialTableData[i].mdid === row.mdid) {
              index = i
              break
            }
          }
          if (index !== null) {
            this.materialTableData.splice(index, 1)
          }
          let aindex = null
          for (let i = 0; i < this.allMaterialData.length; i++) {
            if (this.allMaterialData[i].mdid === row.mdid) {
              aindex = i
              break
            }
          }
          if (aindex !== null) {
            this.allMaterialData.splice(aindex, 1)
          }
          this.fullscreenLoading = false
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {
      })
    }
  }
}
</script>
<style>
  .el-table .warning-row {
    color:#F56C6C;
  }
</style>
